// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df070e32","337":"43c114c3","453":"373bf892","667":"0b7d9f3b"}[chunkId] + ".chunk.js";
};